<script>
  import CodeExample from '../components/CodeExample.svelte';

  const utilityBased = `
  <div class="p-6 max-w-sm mx-auto bg-white rounded-xl shadow-md flex items-center space-x-4">
    <div class="flex-shrink-0">
      <div class="h-8 w-8 bg-lighter rounded-full flex items-center justify-center font-bold">CC</div>
    </div>
    <div>
      <div class="text-xl font-medium text-black">ChitChat</div>
      <p class="text-gray-500">You have a new message!</p>
    </div>
  </div>
  `;

  const component = `
  <button class="bg-brand-base hover:bg-black transition-colors duration-500 ease-in-out text-white font-bold py-4 px-5 rounded-full align-middle">
    Custom classes
  </button>

  <button class="button button-primary-dark">
    Component
  </button>
  `;

  const responsive = `
  <div class="bg-warmWhite md:bg-sunsetPink xl:bg-sageGreen text-black p-4 md:p-6 xl:p-8">
    Resize for responsive padding and background colors.
  </div>
  `;

  const spaceExample = `
  <div class="flex justify-evenly gap-4">
    <div class="flex flex-row space-x-4">
      <div class="w-8 h-8 flex items-center justify-center bg-sunsetPink text-black rounded-full">1</div>
      <div class="w-8 h-8 flex items-center justify-center bg-sageGreen text-black rounded-full">2</div>
      <div class="w-8 h-8 flex items-center justify-center bg-warmWhite text-black rounded-full">3</div>
    </div>
    <div class="flex flex-col space-y-4">
      <div class="w-8 h-8 flex items-center justify-center bg-sunsetPink text-black rounded-full">1</div>
      <div class="w-8 h-8 flex items-center justify-center bg-sageGreen text-black rounded-full">2</div>
      <div class="w-8 h-8 flex items-center justify-center bg-warmWhite text-black rounded-full">3</div>
    </div>
  </div>
  `;
</script>

<template>
  <section id="tailwind-basics" class="page-section bg-sageGreen40">
    <div class="container">
      <h2 class="heading heading-2 my-6">Tailwind basics</h2>

      <div class="space-y-6">
        <p class="copy copy-large">
          The Tailwind docs are fantastic. Every available css property is cleary explained with simple examples. We will quickly explain some key concepts here but before continuing down this page
          please familiarise yourself with the offical Tailwind docs.
        </p>
        <a href="https://v1.tailwindcss.com/docs/installation" class="button button-primary-light">Take me to the Tailwind docs!</a>
      </div>

      <h3 class="heading heading-3 mt-8 mb-6">Utility-based</h3>
      <div class="space-y-6">
        <p class="copy">
          Tailwind is a utility-based framework, which means you compose together atomic classes to achieve your desired styling. If things are done well you shouldn't need to write CSS at all!
        </p>
        {@html utilityBased}
        <CodeExample id="utilityBased" snippet={utilityBased} />
      </div>
      <div class="space-y-6">
        <h3 class="heading heading-3 mt-8 mb-6">Components</h3>
        <p class="copy">
          Keeping a long list of utility classes in sync across many component instances can quickly become a real maintenance burden, that's why we have extracted some pre-built components for you.
          Take our button for example:
        </p>
        <div>
          {@html component}
        </div>
        <CodeExample id="component" snippet={component} />
      </div>

      <h3 class="heading heading-3 mt-8 mb-6">Responsive</h3>
      <div class="space-y-6">
        {@html responsive}
        <CodeExample id="responsive" snippet={responsive} />
      </div>
      <h3 class="heading heading-3 mt-8 mb-6">Layout spacing</h3>
      <div class="space-y-6">
        {@html spaceExample}
        <CodeExample id="spaceExample" snippet={spaceExample} />
      </div>
    </div>
  </section>
</template>
